import React from 'react';

const Banner = () => <div className="profile-page-bg-banner bg-primary d-md-block p-relative" />;

export default Banner;
